export const NEWS_PAGE_SIZE = 10

export const newsPageCount = (total: number) => Math.max(1, Math.ceil(total / NEWS_PAGE_SIZE))
export const newsPagePath = (page: number) => page === 1 ? '/news' : `/news/page/${page}`
export const newsArchivePages = (total: number) => Array.from({ length: newsPageCount(total) - 1 }, (_, index) => index + 2)

export function newsPageItems<T>(stories: T[], page: number): T[] {
  if (!Number.isInteger(page) || page < 1 || page > newsPageCount(stories.length)) return []
  return stories.slice((page - 1) * NEWS_PAGE_SIZE, page * NEWS_PAGE_SIZE)
}

export function newsPaginationLinks(current: number, total: number): (number | 'gap')[] {
  const pages = Array.from({ length: total }, (_, index) => index + 1)
    .filter(page => page === 1 || page === total || Math.abs(page - current) <= 1)
  return pages.flatMap((page, index) => index && page - pages[index - 1] > 1 ? ['gap' as const, page] : [page])
}

export function withNewsArchivePages<T extends { pages: Record<string, { title: string; description: string }> }>(config: T, total: number): T {
  const pages = { ...config.pages }
  for (const page of newsArchivePages(total)) pages[newsPagePath(page)] = {
    title: `Medical News in China – Page ${page} | China Care Editorial`,
    description: `Explore page ${page} of China Care’s news archive: international patient stories, specialist expertise and medical treatment options in China.`,
  }
  return { ...config, pages }
}
